module.exports = __webpack_public_path__ + "f13ac154ccb57d9aebe4d678d7447e88.jpg";